import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
} from "@chakra-ui/react";
import React, { memo, useEffect, useState } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import {
  InputControl,
  TextareaControl,
} from "../../../components/form/formControls";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { transactionHistoryCall } from "../../../api/transactionHistory";
import { StatusTransactionHistory } from "../../../utils/contants";
import { formatDateHourDb } from "../../../utils/tools";
import { formatDate } from "../../../utils/utils";

const schema = Yup.object().shape({
  comment: Yup.string().required("Vui lòng nhập nội dung phản hồi"),
});

const FormReport = memo(
  ({ isOpen, onClose, onSubmit, isEdit, defaultValues }) => {
    const {
      register,
      handleSubmit,
      setValue,
      clearErrors,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      defaultValues: {},
    });

    const [focusStates, setFocusStates] = useState({});
    const [listReports, setListReports] = useState([]);

    const fetchData = async () => {
      try {
        const res = await transactionHistoryCall.list({
          lockingId: defaultValues?.id,
        });

        if (res?.items) {
          setListReports(res.items);

          setValue("comment", "");
          clearErrors("comment");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const handleFocus = (field) => {
      setFocusStates((prev) => ({ ...prev, [field]: true }));
    };

    const handleBlur = (field) => {
      setFocusStates((prev) => ({ ...prev, [field]: false }));
    };

    useEffect(() => {
      fetchData();
    }, [isOpen]);

    const submitHandler = async (data) => {
      try {
        await transactionHistoryCall.create({
          lockingId: defaultValues?.id,
          comment: data.comment || "",
        });

        fetchData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          backgroundColor="var(--color-main)"
          borderRadius={"16px"}
          position={"relative"}
          w={"100%"}
          maxW={"625px"}
        >
          <form onSubmit={handleSubmit(submitHandler)}>
            <Box
              paddingBottom={"80px"}
              h={"86.5vh"}
              w={"100%"}
              overflowY={"scroll"}
              sx={{
                "&::-webkit-scrollbar": {
                  width: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  width: "4px",
                  borderRadius: "50px",
                  background: "var(--color-background)",
                },
                "&::-moz-scrollbar": {
                  width: "4px",
                },
                "&::-moz-scrollbar-thumb": {
                  width: "4px",
                  borderRadius: "50px",
                  background: "var(--color-background)",
                },
              }}
            >
              <Flex
                alignItems={"center"}
                p={"25px 24px 24px 24px"}
                position={"relative"}
                borderBottom={"1px solid var(--border-input-employee)"}
              >
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  Phản hồi locking
                </Text>
                <Box
                  position={"absolute"}
                  top={"24px"}
                  right={"24px"}
                  cursor={"pointer"}
                  onClick={onClose}
                >
                  <Image src={IconX} />
                </Box>
              </Flex>
              <Box
                paddingTop={"24px"}
                paddingBottom={"41px"}
                maxW={"545px"}
                margin={"0 auto"}
              >
                <Box>
                  <TextareaControl
                    type="textarea"
                    label="Thêm phản hồi"
                    placeholder="Nhập phản hồi"
                    errors={errors.comment}
                    register={register("comment")}
                    onFocus={() => handleFocus("comment")}
                    onBlur={() => handleBlur("comment")}
                    state={focusStates["comment"]}
                    mwidth="100%"
                    height="150px"
                  />
                </Box>
                <Box
                  w={"100%"}
                  bottom={"0"}
                  bg={"var(--color-main)"}
                  zIndex={3}
                >
                  <Flex p={"24px 0"} gap={"16px"} justifyContent={"flex-end"}>
                    <Button
                      type="submit"
                      w={"142px"}
                      p={"13px 20px"}
                      fontSize={"15px"}
                      fontWeight={600}
                      color={"var(--color-main)"}
                      borderRadius={"8px"}
                      bg={"var(--color-option-employee-hover)"}
                      _hover={{
                        filter: "brightness(90%)",
                      }}
                    >
                      Thêm phản hồi
                    </Button>
                  </Flex>
                </Box>

                <Box
                  borderTop={"0.5px solid var(--bg-line-employee)"}
                  pt={"16px"}
                >
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Danh sách phản hồi
                  </Text>
                  <Box mt={"8px"} borderRadius={"8px"}>
                    {listReports?.map((item, index) => (
                      <Box
                        key={index}
                        background={"var(--fill-avatar)"}
                        p={"16px 24px 16px 16px"}
                        mt={"16px"}
                        borderRadius={"8px"}
                      >
                        <Flex gap={"8px"} justifyContent={"space-between"}>
                          {item?.status === StatusTransactionHistory.PENDING ? (
                            <Text
                              fontSize={"14px"}
                              color={"var(--text-red-employee)"}
                            >
                              Chưa giải quyết
                            </Text>
                          ) : (
                            <Text
                              fontSize={"14px"}
                              color={"var(--color-status-employ)"}
                            >
                              Đã giải quyết
                            </Text>
                          )}
                        </Flex>

                        <Flex gap={"8px"} mt={"16px"}>
                          <Text fontSize={"14px"}>{item.comment}</Text>
                        </Flex>

                        <Flex
                          gap={"8px"}
                          justifyContent={"flex-end"}
                          mt={"16px"}
                        >
                          <Flex gap={"8px"}>
                            <Text
                              fontSize={"14px"}
                              color={"var(--color-black-label)"}
                            >
                              {item?.bookerObject?.fullName || ""}
                            </Text>
                            <Text
                              fontSize={"14px"}
                              color={"var(--color-black-label)"}
                            >
                              -
                            </Text>
                            <Text
                              fontSize={"14px"}
                              color={"var(--color-option-employee-hover)"}
                            >
                              {item?.createdAt
                                ? formatDate(item?.createdAt)
                                : "-"}
                            </Text>
                          </Flex>
                        </Flex>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Box>
          </form>
        </ModalContent>
      </Modal>
    );
  }
);

export default FormReport;
